import { addDays } from '../utils';

export default function belongsToDayPart(event, dayPart) {
  const dayPartStartDate = new Date(event.dtstart);
  let dayPartEndDate = new Date(event.dtstart);

  const [timeStartHours, timeStartMinutes] = dayPart.timeStart.split(':').map(Number);
  dayPartStartDate.setHours(timeStartHours);
  dayPartStartDate.setMinutes(timeStartMinutes);

  const [timeEndHours, timeEndMinutes] = dayPart.timeEnd.split(':').map(Number);
  dayPartEndDate.setHours(timeEndHours);
  dayPartEndDate.setMinutes(timeEndMinutes);

  if (dayPartEndDate < dayPartStartDate) {
    dayPartEndDate = addDays(dayPartEndDate, 1);
  }

  return [
    [addDays(dayPartStartDate, -1), addDays(dayPartEndDate, -1)],
    [dayPartStartDate, dayPartEndDate],
    [addDays(dayPartStartDate, 1), addDays(dayPartEndDate, 1)],
  ].some(([from, to]) => from <= event.dtstart && event.dtstart < to);
}
